'use strict'

setSiteCookies = require './setSiteCookies'
Groupon.setWindowLocation = require '../../../src/frontend/helper/general/m_setWindowLocation'
module.exports = Groupon.Utils.changeUserLanguage = (language) ->
  setSiteCookies user_locale: null
  setSiteCookies user_locale: language
  hreflang = "[hreflang='" + language.replace('_', '-') + "']"

  if (alternate = $("head link" + hreflang).attr("href"))
    href = alternate
  else
    href = '/'

  Groupon.setWindowLocation href



// WEBPACK FOOTER //
// ./core/frontend/groupon_modules/changeUserLanguage.coffee